import { TableColumn } from '../../../components/forms/form-entries/form-entry-list/entry-list/dynamic-table/dynamic-table.component';
import { WeeklySiteInspection } from './weekly-site-inspection.model';

export class WeeklySiteInspectionListItem {
  /** When the form was submitted ("Entry Date" column) */
  submissionDate: Date | null = null;

  /** The person who submitted the form ("User" column) */
  submittedByName: string = '';

  /** The inspection date ("Date" column) */
  date: Date | null = null;

  /** Job name ("Job Name" column) */
  jobName: string = '';

  /** Inspector ("Inspector" column) */
  inspector: string = '';

  /** Count of uploaded photos ("Upload Photos" column) */
  photoCount: number = 0;

  id: string = '';

  constructor(data?: Partial<WeeklySiteInspectionListItem>) {
    if (data) {
      Object.assign(this, data);
    }
  }

  static getTableColumns(): TableColumn[] {
    const columns: TableColumn[] = [];
    const instance = new WeeklySiteInspectionListItem();
    const fieldMappings = WeeklySiteInspection.getFieldMappings();
    
    // Get all properties of the class
    Object.keys(instance).forEach(key => {
      // Skip the id property as it's handled separately
      if (key === 'id') return;

      // Determine the type based on the property value
      let type: 'text' | 'date' | 'action' | 'status' = 'text';
      const value = instance[key as keyof WeeklySiteInspectionListItem];
      
      if (value instanceof Date || (value === null && key.toLowerCase().includes('date'))) {
        type = 'date';
      }
      // All other values default to 'text' type

      // Add the column if it has a mapping
      if (fieldMappings[key]) {
        columns.push({
          key,
          label: fieldMappings[key],
          type,
          sortable: true
        });
      }
    });

    

    return columns;
  }

  static fromApiResponse(data: any): WeeklySiteInspectionListItem {
    return new WeeklySiteInspectionListItem({
      id: data.id,
      submissionDate: data.submissionDate ? new Date(data.submissionDate) : null,
      submittedByName: data.submittedByName,
      date: data.date ? new Date(data.date) : null,
      jobName: data.jobName,
      inspector: data.inspector,
      photoCount: data.photoCount || 0
    });
  }
} 